module.exports = __webpack_public_path__ + "img/2-1-b.9d2f1c2d.jpg";